<template>
  <Modal
    :open="props.open"
    hide-close
    :custom-height="'h-auto lg:h-[350px]'"
    :custom-width="'lg:!w-[650px]'"
  >
    <template #modal-header>
      <div class="flex flex-col text-strongest">
        <div class="flex gap-2 items-center">
          <Icon name="Info" class="h-4 w-4 text-info" />
          <p class="font-inter text-sm text-info font-semibold">In-progress</p>
        </div>
        <h3 class="font-semibold text-[20px] lg:text-[28px]">
          You have an in-progress change investment
        </h3>
      </div>
    </template>
    <template #modal-body>
      <div class="p-6 text-strongest">
        <div class="flex flex-col gap-4 font-inter text-stronger">
          <p class="font-inter font-medium text-strong">
            You've already started signing documents for this conversion. If you go back and make
            changes, all signed documents will be voided and you'll need to re-sign everything.
          </p>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="w-full flex justify-end gap-2">
        <Button @click="$emit('discard')" variant="paper-primary" size="md">
          <template #label>Start over</template>
        </Button>
        <Button @click="$emit('resume')" variant="primary-grey" size="md">
          <template #label>Continue With Previous</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { Modal, Icon, Button } from "@/components";

const props = defineProps({
  open: { type: Boolean, required: true },
});

defineEmits(["close-modal", "discard", "resume"]);
</script>
